import React from 'react';
import Div from "@jumbo/shared/Div";
import useJumboContentLayout from "@jumbo/hooks/useJumboContentLayout";

const JumboContentLayoutHeader = ({children}) => {
    const contentLayout = useJumboContentLayout();
    return (
        <Div
            sx={{
                ...contentLayout?.header?.sx,
                backgroundColor : '#2fa5c8'
            }}
            className="CmtLayout-header"
        >
            {children}
        </Div>
    );
};

export default JumboContentLayoutHeader;
